module.exports = __webpack_public_path__ + "static/media/ncf_logo.0be681d3.jpeg";